import React from 'react';
import '../../public/css/passwordRecovery.css';
import { Panel } from 'react-bootstrap';

class ResetPasswordLayout extends React.Component {
	render() {
		return (
			<div className="container">
				<div className="reset-password-container">
					<Panel>{this.props.children}</Panel>
				</div>
			</div>
		);
	}
}

export default ResetPasswordLayout;



// WEBPACK FOOTER //
// ./src/views/layouts/ResetPasswordLayout.js